import { render } from "./ForgotPasswordRequested.vue?vue&type=template&id=3642174a"
const script = {}

import "./ForgotPasswordRequested.vue?vue&type=style&index=0&id=3642174a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__